const historyKeys = {
  all: ['historyLog'],
  stats: (filters: Record<string, any>) => [...historyKeys.all, 'stats', filters],
  filtered: (filters: Record<string, any>) => [...historyKeys.all, 'filtered', filters],
  export: (filters: Record<string, any>) => [...historyKeys.all, 'export', filters]
};

export default historyKeys;
